<template>
  <b-modal
    id="page-search-modal"
    :ok-title="trans(block && block.id ? 'save' : 'create')"
    :cancel-title="trans('cancel')"
    no-enforce-focus
    :title="trans('search')"
    @shown="onShown"
    @hidden="onHidden"
    @ok="onSave"
  >
    <p>{{ trans('microsite_search_block_about') }}</p>
    <b-row align-v="end">
      <b-col>
        <b-form-group :label="trans('search_cta')">
          <b-form-input
            v-model="button_text"
            :placeholder="trans('search')"
            :disabled="busy"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-form-group :label="trans('search_placeholder')">
          <b-form-input
            v-model="placeholder"
            :placeholder="trans('keywords')"
            :disabled="busy"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  export default {
    props: {
      organization: Object,
      page: Object,
      block: Object,
      after: Number,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        shown: false,
        placeholder: null,
        button_text: null,
      }
    },
    computed: {
      isAdmin() {
        return !!this.organization && !!this.organization.auth_user
      },
      formInputs() {
        if (!this.selectedForm.new_form) return []
        return this.selectedForm.new_form.form_questions
      },
      serialized() {
        return {
          type: 'search',
          button_text: this.button_text,
          meta: {
            placeholder: this.placeholder
          },
          after: this.after,
        }
      },
    },
    watch: {
      block() {
        this.deserialize()
      }
    },
    methods: {
      deserialize() {
        this.placeholder = !!this.block && !!this.block.meta ?
          (this.block.meta.placeholder || null) :
          null
        this.button_text = !!this.block ?
          (this.block.button_text || null) :
          null
      },
      onShown() {
        this.deserialize()
        this.shown = true
      },
      onHidden() {
        this.busy = false
        this.error = null
        this.placeholder = null
        this.button_text = null
        this.shown = false
      },
      onSave(e) {
        e.preventDefault()
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/page/${this.page.id}/block`
        if (this.block && this.block.id) url += `/${this.block.id}`
        axios[this.block && this.block.id ? 'patch' : 'post'](url, this.serialized)
        .then(response => {
          this.busy = false
          this.$emit('saved', response.data)
          this.$bvModal.hide('page-search-modal')
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
    },
    mounted() {
      window.pageSearchModal = this
    },
  }
</script>